import { createReducer } from "@reduxjs/toolkit";
import {
  AddSiteCertification,
  AddSiteSupplier,
  getOverdueAuditListAsyncSuccess,
  getSiteListSuccess,
  getUpcomingAuditListAsyncSuccess,
  loadingList,
  RemoveSiteSupplier,
  SetSiteCategory,
  SetSiteCertification,
  SetSiteSupplier,
} from "./siteAction";

export interface ISiteState {
  siteList: Array<any>;
  upcomingAuditList: Array<any>;
  overdueAuditList: Array<any>;
  dataCount: number;
  isLoading: boolean;
  siteSuppliers: Array<any>;
  categories: Array<any>;
  certificates: Array<any>;
}

const initialState: ISiteState = {
  siteList: [],
  upcomingAuditList: [],
  overdueAuditList: [],
  dataCount: 0,
  isLoading: false,
  siteSuppliers: [],
  categories: [],
  certificates: [],
};

export const siteReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getSiteListSuccess, (state, action) => {
      state = {
        ...state,
        siteList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getUpcomingAuditListAsyncSuccess, (state, action) => {
      state = {
        ...state,
        upcomingAuditList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getOverdueAuditListAsyncSuccess, (state, action) => {
      state = {
        ...state,
        overdueAuditList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(AddSiteSupplier, (state, action) => {
      let update = {
        ...action.payload,
        key: (state.siteSuppliers ?? [])?.length + 1,
      };
      console.log(update);
      state = {
        ...state,
        siteSuppliers: (state?.siteSuppliers ?? []).concat(update),
      };
      console.log(state?.siteSuppliers);
      return state;
    })
    .addCase(SetSiteSupplier, (state, action) => {
      let data = (action.payload ?? []).map((item, index) => {
        let cpy = { ...item };
        cpy["key"] = index + 1;
        return cpy;
      });
      state = {
        ...state,
        siteSuppliers: data,
      };
      return state;
    })
    .addCase(RemoveSiteSupplier, (state, action) => {
      let filter = state.siteSuppliers.filter(
        (item) => item.key !== action.payload.key
      );
      state = {
        ...state,
        siteSuppliers: filter,
      };
      return state;
    })
    .addCase(SetSiteCategory, (state, action) => {
      state = {
        ...state,
        categories: action.payload,
      };
      return state;
    })
    .addCase(SetSiteCertification, (state, action) => {
      state = {
        ...state,
        certificates: action.payload,
      };
      return state;
    })
    .addCase(AddSiteCertification, (state, action) => {
      state = {
        ...state,
        certificates: state.certificates.concat(action.payload),
      };
      return state;
    });
});
